import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { FacturaOrdenCompraGastoPagingRes, GetFacturaOrdenCompraGastoParams } from "@/shared/interfaces/erp/factura_compra_gasto/factura-compra-gasto.interface";
import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi()
export const useFetchFacturaCompraGastoCombinado = (params?: GetFacturaOrdenCompraGastoParams) => {
  return useQuery({
    queryKey: ['FacturaOrdenCompraGasto', ...Object.values(params || {})],
    queryFn: async () => {
      return getFacturaCompraGastoCombinado(params)
    },
    //enabled
  })
}
export const getFacturaCompraGastoCombinado = async (params?: GetFacturaOrdenCompraGastoParams) => {
  const queryParams = getUrlParamsFetch({ ...params })
  return get<FacturaOrdenCompraGastoPagingRes>(`${urlBackend}api/v1/facturaordencompragasto/?${queryParams}`, true)
}
